import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const FlagIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M4.00002 1.33398V2.66732H13.3334L12 6.00065L13.3334 9.33398H4.00002V14.6673H2.66669V1.33398H4.00002Z" />
  </Icon>
);

export default memo(FlagIcon);
